import React from 'react';
import { 
  BookOpen, 
  Rocket, 
  Code, 
  Laptop, 
  Palette, 
  Globe, 
  Camera, 
  Zap, 
  Film, 
  Headphones 
} from 'lucide-react';

const CourseCard = ({ course }) => {
    // Array of random icons
    const randomIcons = [
        BookOpen, 
        Rocket, 
        Code, 
        Laptop, 
        Palette, 
        Globe, 
        Camera, 
        Zap, 
        Film, 
        Headphones
    ];

    // Function to get a random icon
    const getRandomIcon = () => {
        const randomIndex = Math.floor(Math.random() * randomIcons.length);
        const RandomIcon = randomIcons[randomIndex];
        return RandomIcon;
    };

    if (!course) {
        return (
            <div className="col-lg-4">
                <div className="alert alert-danger" role="alert">
                    Course data is missing or invalid
                </div>
            </div>
        );
    }

    const RandomIcon = getRandomIcon();

    return (
        <div className="col-lg-4">
            <div className="card overflow-hidden hover-img" style={styles.card}>
                <div className="position-relative" style={styles.positionRelative}>
                    <div style={styles.iconContainer}>
                        <RandomIcon 
                            size={100} 
                            color="#007bff" 
                            strokeWidth={1.5} 
                            className="mx-auto" 
                        />
                    </div>
                    <span
                        className="badge text-bg-light text-dark fs-2 lh-sm mb-9 me-9 py-1 px-2 fw-semibold position-absolute bottom-0 end-0"
                        style={styles.badge}
                    >
                        {course.duration} hours
                    </span>
                </div>
                <div className="card-body p-4" style={styles.cardBody}>
                    <span className="badge text-bg-light fs-2 py-1 px-2 lh-sm mt-3" style={styles.titleBadge}>
                        {course.title}
                    </span>
                    <a
                        href={`/courses/${course.id}`}
                        className="d-block my-4 fs-5 text-dark fw-semibold link-primary"
                        style={styles.link}
                    >
                        {course.description}
                    </a>
                    <div className="d-flex align-items-center gap-4" style={styles.infoContainer}>
                        <div className="d-flex align-items-center gap-2" style={styles.infoItem}>
                            <i className="ti ti-eye text-dark fs-5"></i>
                            {course.views}
                        </div>
                        <div className="d-flex align-items-center gap-2" style={styles.infoItem}>
                            ${course.price}
                        </div>
                        <div className="d-flex align-items-center fs-2 ms-auto" style={styles.date}>
                            <i className="ti ti-point text-dark"></i>
                            {course.date}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const styles = {
    ...{
        card: {
            width: '100%',
            maxWidth: '350px',
            height: '450px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            margin: 'auto',
        },
        positionRelative: {
            position: 'relative',
        },
        iconContainer: {
            width: '100%',
            height: '200px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#f8f9fa',
        },
        badge: {
            zIndex: 1,
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
        },
        cardBody: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
        },
        titleBadge: {
            display: 'block',
            textAlign: 'center',
            marginBottom: '8px',
        },
        link: {
            marginTop: 'auto',
            color: 'inherit',
            textDecoration: 'none',
        },
        infoContainer: {
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
        },
        infoItem: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
        },
        date: {
            marginLeft: 'auto',
            display: 'flex',
            alignItems: 'center',
        },
    }
};

export default CourseCard;